import * as React from 'react';

import { DraggableDialog } from '~/components/Dialogs/components/DraggableDialog';
import { SendMessageToHRDialogContent } from '~/features/SendMessageToHRDialog/SendMessageToHRDialogContent';
import { useSendMessageToHRDialog } from '~/features/SendMessageToHRDialog/useSendMessageToHRDialog';

type PropsType = {
  open: boolean;
  onClose: () => void;
};

export const SendMessageToHRDialog = (props: PropsType) => {
  const { open, onClose } = props;

  const { messageContacts } = useSendMessageToHRDialog();

  return (
    <DraggableDialog open={open} onClose={onClose} fullWidth={true}>
      <SendMessageToHRDialogContent
        onClose={onClose}
        companyHrContacts={messageContacts}
      />
    </DraggableDialog>
  );
};
